import type { ReactNode } from 'react';

type FormFieldProps = {
  label: string;
  htmlFor: string;
  error?: string;
  hint?: string;
  children: ReactNode;
  /** Extra classes on the .field wrapper (e.g. "span-2" inside a .cols-2 form grid). */
  className?: string;
};

/** Labeled wrapper around one input/select/textarea, with a hint or error line. */
export function FormField({ label, htmlFor, error, hint, children, className }: FormFieldProps) {
  return (
    <div className={className ? `field ${className}` : 'field'}>
      <label className="field-label" htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      {error ? (
        <p role="alert" className="field-error">
          {error}
        </p>
      ) : hint ? (
        <p className="field-help">{hint}</p>
      ) : null}
    </div>
  );
}
